<template>
  <div class="board-body">
    <div>
      <modal-box
        class="modal-window"
        v-bind:title="modalBox.title"
        v-bind:message="modalBox.msg"
        v-bind:buttonCaption="modalBox.btnCaption"
        v-show="modalBox.show"
        @close="hideModalBox"
      />
      <modal-share
        class="modal-window"
        v-show="isModalVisible"
        @close="closeModal"
      />
      <div class="no-data" v-show="noData">
        <div class="options">
          <div
            v-if="false"
            class="option border-reight"
            v-on:click="showSlpProfile"
          >
            <div class="logo file-icon slp"></div>
            <h2>Zeitreihe erstellen</h2>
            <p>
              Falls Sie keinen Lastgang zur Verfügung haben, können Sie hier
              eine Lastkurve generieren.
            </p>
          </div>
          <div class="option" v-on:click="callUpload()">
            <img class="logo" src="../assets/img/file.png" />
            <h2>Dokumente hochladen</h2>
            <p>
              Lesen Sie Dateien per Drag and Drop ein, oder klicken Sie hier um
              Ihr Laufwerk durchzusuchen.
            </p>
          </div>
        </div>
      </div>
      <SlpProfile
        class="modal-window"
        v-show="isSlpProfileVisible"
        @close="closeSlpProfile"
      />
      <div class="customdropzone margin" v-show="!uploadActive">
        <div
          v-for="(f, i) in files"
          :key="i"
          :index="parseInt(i) + 1"
          class="dz-preview dz-file-preview large margin"
          v-bind:class="{ checked: f.selected }"
          v-bind:style="{ zoom: getZoom() }"
        >
          <div dz-preview-wrapper class="dz-preview-wrapper">
            <div class="dz-image">
              <img
                v-bind:src="f.img"
                data-dz-thumbnail-bg
                class="data-dz-thumbnail-bg large"
              />
              <div
                class="data-dz-thumbnail-bg-overlay loading"
                v-show="f.loading"
              >
                <div class="progress-icon"></div>
              </div>
              <div
                data-dz-thumbnail-bg-overlay
                class="data-dz-thumbnail-bg-overlay large"
              >
                <ul class="tools">
                  <li class="share" v-on:click="showModal()">
                    <a>share</a>
                  </li>
                  <!--
                    TODO:
                  <li class="share" v-on:click="alertFunctionNA()">
                    <a>share</a>
                  </li>
                  -->
                  <li class="download">
                    <a>
                      <download-excel
                        worksheet="My Worksheet"
                        name="filename.xls"
                        :data="f.dataForExcel"
                        class="download-excel"
                      >
                        <span class="accessibility">Download xls</span>
                      </download-excel>
                    </a>
                  </li>
                  <li
                    data-dz-delete
                    class="delete"
                    v-on:click="removeElement(f)"
                  >
                    <a>delete</a>
                  </li>
                </ul>
                <div class="checker">
                  <span data-dz-checkbox v-bind:class="{ checked: f.selected }">
                    <input type="checkbox" v-on:click="check(f)" />
                  </span>
                </div>
                <a class="btn-oval mt-l" v-on:click="goToLoadProfile(f)"
                  >Anzeigen</a
                >
              </div>
            </div>
            <div class="dz-progress">
              <span class="dz-upload" data-dz-uploadprogress></span>
            </div>
            <div class="dz-details">
              <h2 class="rename dz-filename" contenteditable="true">
                <span data-dz-name>{{ f.name }}</span>
              </h2>
            </div>
            <div class="dz-error-message">
              <span data-dz-errormessage></span>
            </div>
            <div class="dz-success-mark">
              <i class="fa fa-check"></i>
            </div>
            <div class="dz-error-mark">
              <i class="fa fa-close"></i>
            </div>
          </div>
        </div>
      </div>
      <vue-dropzone
        :options="dropzoneOptions"
        :include-styling="false"
        v-on:vdropzone-thumbnail="thumbnail"
        v-on:vdropzone-file-added="attachListener"
        v-on:vdropzone-success="successEvent"
        v-on:vdropzone-error="errorEvent"
        v-on:vdropzone-max-files-exceeded="maxFileCountReached"
        v-on:vdropzone-sending="sendingEvent"
        v-show="uploadActive"
        id="customdropzone"
        ref="dropzone"
        class="customdropzone dragNDropBackGround"
      >
        <i class="fas fa-cloud-upload-alt fa-7x"></i>
        <h2>DRAG & DROP</h2>
        <p>
          Ziehen Sie Ihre CSV-Dateien hier, oder clicken Sie um durchzusuchen.
        </p>
      </vue-dropzone>
      <div class="zoom" v-show="isZoomVisible">
        <input type="range" min="65" max="120" step="5" v-model="zoom" />
      </div>
      <!--<div class="button-wrapper">
        <div class="plus-button" v-on:click="toggleUpload()" ref="plusButton">
          +
        </div>
      </div>-->
      <div class="plus-btn-options" v-if="false" v-show="isAddOptionsVisible">
        <div class="option" v-on:click="callUpload()">
          <div class="file-icon file"></div>
          <h2>Datei</h2>
          <p>xls, csv, MSCONS, txt</p>
        </div>
        <div class="option" v-on:click="showSlpProfile">
          <div class="file-icon slp"></div>
          <h2>Profil</h2>
          <p>Lastgang erstellen</p>
        </div>
      </div>
      <div class="group-actions" v-show="showGroupAction()">
        <div class="inner">
          <p>
            <span class="selected-items">{{ countSelectedItems() }}</span>
            <span class="selected-items-label">Ausgewählte Lastgänge</span>
          </p>
          <ul class="toolbar">
            <li class="list-item share">
              <a class="link">share</a>
            </li>
            <li class="list-item download">
              <a class="link">download</a>
            </li>
            <li class="list-item delete">
              <a class="link">delete</a>
            </li>
            <li class="list-item more">
              <div class="dropdown">
                <a class="link dropdown-toggle" v-on:click="toggleMore()"
                  >More</a
                >
                <ul class="dropdown-menu" v-show="showMore">
                  <li class="list-item" v-on:click="sumSelectedLoads()">
                    <a class="link">Summenlastgang</a>
                  </li>
                  <li class="list-item">
                    <a class="link" v-on:click="avrSelectedLoads()"
                      >Mittelwert-Lastgang</a
                    >
                  </li>
                  <li class="list-item">
                    <a class="link" v-on:click="hedgeSelectedLoads()">Hedgen</a>
                  </li>
                  <li class="list-item">
                    <a class="link" v-on:click="forecastSelectedLoads()"
                      >Ausrollen 2020</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone';
import Chart from './charts/LineChart.vue';
import downloadExcel from 'vue-json-excel';
import ModalShare from './modals/ModalShare.vue';
import ModalBox from './modals/ModalBox.vue';
import SlpProfile from './SlpProfile.vue';

//amplify
import { components } from 'aws-amplify-vue';

export default {
  name: 'DocumentPage',

  data() {
    return {
      id: '',
      name: '',
      files: [],
      modalBox: {
        show: false,
        title: '',
        msg: '',
        btnCaption: '',
      },
      isModalVisible: false,
      isSlpProfileVisible: false,
      showMore: false,
      isZoomVisible: false,
      isAddOptionsVisible: false,
      uploadActive: false,
      hideTimer: null,
      noData: false,
      zoom: 90,
      dropzoneOptions: {
        previewTemplate: this.template(),
        maxFiles: 20,
        url: this.parserApi(),
        acceptedFiles: '.pdf',
      },
    };
  },

  components: {
    Chart,
    vueDropzone,
    downloadExcel,
    ModalShare,
    ModalBox,
    SlpProfile,
    ...components,
  },
  methods: {
    parserApi: function () {
      //if (location.host == 'localhost:8080')
      var url = 'http://127.0.0.1:1888';
      /*else
        var url = 'https://swy6kieajd.execute-api.eu-central-1.amazonaws.com/dev'; */
      url += '/separate-pdf-pages';
      return url;
    },
    tsOperationsApi: function () {
      if (location.host == 'localhost:8080') var url = 'http://127.0.0.1:7000';
      else
        var url =
          'https://7ll1m1w8md.execute-api.eu-central-1.amazonaws.com/dev';
      return url;
    },

    template: function () {
      return `
        <div class="dz-preview dz-file-preview">
                <div dz-preview-wrapper class="dz-preview-wrapper">
                    <div class='container'>
                    </div>
                    <div class="dz-image">
                        <div data-dz-thumbnail-bg class="data-dz-thumbnail-bg loading">
                            <div data-dz-thumbnail-bg-overlay class="data-dz-thumbnail-bg-overlay loading">
                              <div class='progress-icon'>
                              </div>
                            </div>
                        </div>
                    </div>
                    <div class="dz-progress">
                        <span class="dz-upload" data-dz-uploadprogress></span>
                    </div>
                    <div class="dz-details">
                        <h2 class="rename dz-filename" contenteditable="true">
                            <span data-dz-name ></span>
                        </h2>
                    </div>
                    <div class="dz-error-message">
                        <span data-dz-errormessage></span>
                    </div>
                    <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                    <div class="dz-error-mark"><i class="fa fa-close"></i></div>
                </div>
        </div>`;
    },

    thumbnail: function (file, dataUrl) {
      var j, len, ref, thumbnailElement;
      if (file.previewElement) {
        file.previewElement.classList.remove('dz-file-preview');
        ref = file.previewElement.querySelectorAll('[data-dz-thumbnail-bg]');
        for (j = 0, len = ref.length; j < len; j++) {
          thumbnailElement = ref[j];
          thumbnailElement.alt = file.name;
          thumbnailElement.style.backgroundImage = 'url("' + dataUrl + '")';
        }
        return setTimeout(
          (function () {
            return function () {
              return file.previewElement.classList.add('dz-image-preview');
            };
          })(this),
          1
        );
      }
    },

    attachListener: function (file) {
      var j, len, checkboxElements, removeButton;
      if (file.previewElement) {
        checkboxElements =
          file.previewElement.querySelectorAll('[data-dz-checkbox]');
        for (j = 0, len = checkboxElements.length; j < len; j++) {
          checkboxElements[j].addEventListener(
            'click',
            function () {
              if (this.classList.contains('checked')) {
                this.classList.remove('checked');
                file.previewElement.classList.remove('checked');
              } else {
                this.classList.add('checked');
                file.previewElement.classList.add('checked');
              }
            },
            false
          );
        }
        removeButton = file.previewElement.querySelectorAll('[data-dz-delete]');
        for (j = 0, len = removeButton.length; j < len; j++) {
          removeButton[j].addEventListener(
            'click',
            function () {
              file.previewElement.remove();
            },
            false
          );
        }
      }
    },

    check: function (f) {
      f.selected = !f.selected;
    },

    countSelectedItems() {
      return this.files.filter((v) => v.selected).length;
    },

    showGroupAction() {
      return this.files.filter((v) => v.selected).length > 0;
    },

    showDropZone() {
      this.uploadActive = true;
      this.isAddOptionsVisible = true;
      this.noData = false;
    },

    showAddOptions() {
      clearInterval(this.hideTimer);
      this.isAddOptionsVisible = true;
    },

    hideDropZone() {
      this.uploadActive = false;
      this.isAddOptionsVisible = false;
      if (this.files.length > 0) {
        this.isZoomVisible = true;
        this.noData = false;
      } else {
        this.isZoomVisible = false;
        this.noData = true;
      }
    },

    hideAddOptionsWithDelay() {
      this.hideTimer = setTimeout(this.hideAddOptions, 500);
    },

    hideAddOptions() {
      this.isAddOptionsVisible = false;
    },

    toggleMore() {
      this.showMore = !this.showMore;
    },

    toggleUpload() {
      this.uploadActive = !this.uploadActive;
      if (this.uploadActive) {
        this.showDropZone();
        this.showAddOptions();
        this.$refs.plusButton.classList.add('clicked');
      } else {
        this.hideDropZone();
        this.hideAddOptionsWithDelay();
        this.$refs.plusButton.classList.remove('clicked');
      }
    },

    callUpload() {
      this.toggleUpload();
      this.$refs.dropzone.$refs.dropzoneElement.click();
    },

    sumSelectedLoads() {
      //get the selected files
      var selectedFiles = this.files.filter((f) => f.selected);
      var file = selectedFiles[0];

      //init file
      //TODO: init file with resquest response
      var f = {
        id: new Date().getUTCMilliseconds(),
        name: 'Mittelwert-Lastgang',
        previewElement: file.previewElement,
        previewTemplate: file.previewTemplate,
        processing: file.processing,
        size: file.size,
        series: file.series,
        status: file.status,
        type: file.type,
        upload: file.upload,
        webkitRelativePath: file.webkitRelativePath,
        width: file.width,
        xhr: file.xhr,
        XMLHttpRequest: file.xhr,
        selected: false,
      };

      //collect selected series
      var series = [];
      var i;
      for (i = 0; i < selectedFiles.length; i++) {
        series.push(selectedFiles[i].series[0]);
      }

      //set API params
      let formData = new FormData();
      formData.append('ts_list', JSON.stringify(JSON.stringify(series)));

      var url = this.tsOperationsApi();
      url += '/sum';
      fetch(url, { body: formData, method: 'post' })
        .then((response) => response.json())
        .then((json) => {
          //TODO: simplify
          f.series[0].data = JSON.parse(JSON.parse(json)[0].data);
          this.$set(this.files, this.files.length, f);
        });

      //hide menu
      this.toggleMore();
    },

    avrSelectedLoads() {
      //get the selected files
      var selectedFiles = this.files.filter((f) => f.selected);
      var file = selectedFiles[0];

      //init file
      //TODO: init file with resquest response
      var f = {
        id: new Date().getUTCMilliseconds(),
        name: 'Mittelwert-Lastgang',
        previewElement: file.previewElement,
        previewTemplate: file.previewTemplate,
        processing: file.processing,
        size: file.size,
        series: file.series,
        status: file.status,
        type: file.type,
        upload: file.upload,
        webkitRelativePath: file.webkitRelativePath,
        width: file.width,
        xhr: file.xhr,
        XMLHttpRequest: file.xhr,
        selected: false,
      };

      //init variables
      var arrSum = [];
      var i, j, sum, x, y;

      //collect selected series
      var series = [];
      for (i = 0; i < selectedFiles.length; i++) {
        series.push(selectedFiles[i].series[0]);
      }

      //set API params
      let formData = new FormData();
      formData.append('ts_list', JSON.stringify(JSON.stringify(series)));

      //post and get results
      fetch(
        'https://7ll1m1w8md.execute-api.eu-central-1.amazonaws.com/dev/average',
        { body: formData, method: 'post' }
      )
        .then((response) => response.json())
        .then((json) => {
          //TODO: simplify
          f.series[0].data = JSON.parse(JSON.parse(json)[0].data);
          this.$set(this.files, this.files.length, f);
        });

      //hide menu
      this.toggleMore();
    },

    hedgeSelectedLoads() {
      //get the selected files
      var selectedFiles = this.files.filter((f) => f.selected);

      //init variables
      var i, uniqueId;

      for (i = 0; i < selectedFiles.length; i++) {
        //get file
        var file = selectedFiles[i];
        var uniqueId = Math.random().toString(36).substr(2, 16);
        //init file
        //TODO: init file with resquest response
        var f = {
          id: new Date().getUTCMilliseconds(),
          name: file.name + '-Hedge',
          previewElement: file.previewElement,
          previewTemplate: file.previewTemplate,
          processing: file.processing,
          size: file.size,
          series: file.series,
          status: file.status,
          type: file.type,
          upload: file.upload,
          webkitRelativePath: file.webkitRelativePath,
          width: file.width,
          xhr: file.xhr,
          XMLHttpRequest: file.xhr,
          selected: false,
        };

        //set API params
        let formData = new FormData();
        formData.append('time_serie', JSON.stringify(JSON.stringify(f.series)));

        //post and get results
        fetch(
          'https://7ll1m1w8md.execute-api.eu-central-1.amazonaws.com/dev/hedge',
          { body: formData, method: 'post' }
        )
          .then((response) => response.json())
          .then((json) => {
            //TODO: simplify
            f.series[0].data = JSON.parse(JSON.parse(json)[0].data);
            this.$set(this.files, this.files.length, f);
          });
      }

      //hide menu
      this.toggleMore();
    },
    ForecastApi: function () {
      if (location.host == 'localhost:8080') var url = 'http://127.0.0.1:8000';
      else
        var url =
          'https://7ll1m1w8md.execute-api.eu-central-1.amazonaws.com/dev';
      return url;
    },
    forecastSelectedLoads() {
      //get the selected files
      var selectedFiles = this.files.filter((f) => f.selected);

      //init variables
      var i, uniqueId;

      for (i = 0; i < selectedFiles.length; i++) {
        //get file
        var file = selectedFiles[i];
        /*var uniqueId = Math.random()
          .toString(36)
          .substr(2, 16);*/
        //init file
        //TODO: init file with resquest response
        var f = {
          id: new Date().getUTCMilliseconds(),
          name: file.name + '-Ausgerollt',
          previewElement: file.previewElement,
          previewTemplate: file.previewTemplate,
          processing: file.processing,
          size: file.size,
          series: file.series,
          status: file.status,
          type: file.type,
          upload: file.upload,
          webkitRelativePath: file.webkitRelativePath,
          width: file.width,
          xhr: file.xhr,
          XMLHttpRequest: file.xhr,
          selected: false,
        };

        //set API params
        let formData = new FormData();
        formData.append('loadcurve', JSON.stringify(JSON.stringify(f.series)));
        formData.append('state', 'NW');
        formData.append('begin', '2020-01-01');
        formData.append('end', '2020-12-31');
        formData.append('freq', 'H');

        var url = this.ForecastApi();
        url += '/predict';
        fetch(url, {
          body: formData,
          method: 'post',
        })
          .then((response) => response.json())
          .then((json) => {
            //TODO: simplify
            f.series[0].data = JSON.parse(JSON.parse(json)[0].data);
            this.$set(this.files, this.files.length, f);
          });
      }

      //hide menu
      this.toggleMore();
    },

    successEvent: function (file) {
      var res = JSON.parse(file.xhr.responseText);
      var i;
      for (i = 0; i < res.length; i++) {
        var f = {
          id: new Date().getUTCMilliseconds(),
          dataURL: file.dataUrl,
          height: file.height,
          lastModified: file.lastModified,
          lastModifiedDate: file.lastModifiedDate,
          name: res[i].name,
          previewElement: file.previewElement,
          previewTemplate: file.previewTemplate,
          processing: file.processing,
          size: file.size,
          status: file.status,
          type: file.type,
          upload: file.upload,
          webkitRelativePath: file.webkitRelativePath,
          width: file.width,
          xhr: file.xhr,
          XMLHttpRequest: file.xhr,
          selected: false,
          loading: true,
          dataForExcel: null,
        };
        f.img = res[i].img;
        this.$set(this.files, this.files.length, f);
        this.hideDropZone();
        this.hideLoadingIcon(f);
      }
      file.previewElement.remove();
    },

    triggerSend() {
      this.$refs.dropzone.processQueue();
    },

    sendingEvent(file, xhr, formData) {
      formData.append('type', 'document');
    },

    hideLoadingIcon: function (f) {
      /*var callback = function(f, it) {
        var loaded = false;
        if (typeof it.$refs[f.id] !== "undefined")
          loaded = it.$refs[f.id][0]._data.loaded;
        if (!loaded)
          setTimeout(() => {
            callback(f, it);
          }, 100);
        else {
          f.loading = false;
          return loaded;
        }
      };
      if (callback(f, this)) f.loading = false;*/
      f.loading = false;
    },

    errorEvent: function (file, message, xhr) {
      //TODO: get error message
      //debugger;
    },

    removeElement: function (f) {
      //remove from component
      this.files = this.files.filter((x) => {
        return x != f;
      });

      /*
      //romove from database
      //production
      var url ='https://iles4b4z6f.execute-api.us-west-2.amazonaws.com/dev/delete_ts'
      //local
      //var url = 'http://127.0.0.1:1100/delete_ts';
      var formData = new FormData();
      formData.append('id', id)
      fetch(url, {body: formData, method: 'delete'})
        .then(
          data =>{
            return
          }
        )
      */
    },

    goToLoadProfile: function (f) {
      //var series = JSON.parse(f.series);
      var series = f.series[0];
      var loadProfile = {
        name: f.name,
        unit: series.unit,
        begin: series.begin,
        end: series.end,
        sum: series.sum,
        count: series.count,
        data: series.data,
      };
      this.$router.push({
        name: 'loadprofile',
        //params: { series: this.initSeries}
        params: { loadProfile: loadProfile },
      });
    },

    //get formatted data for export
    initExcelData(f) {
      //check if the formatted data is already created
      if (f.dataForExcel == null) {
        var data = f.series[0].data;
        var newData = [];

        //deep copy array
        for (var i = 0; i < data.length; i++) newData[i] = data[i].slice();

        //format
        newData.forEach((e) => {
          e[0] = this.getFrontEndDateFormat(e[0]);
        });
        return newData;
      }
      return f.dataForExcel;
    },

    //format data to display in front end
    getFrontEndDateFormat(value) {
      var temp = new Date(parseInt(value));
      return (
        temp.toLocaleDateString('de-DE', this.dateOptions) +
        ' ' +
        temp.toLocaleTimeString()
      );
    },

    //@params strSeries series as JSON-Text
    /*setSeries: function(strSeries) {
      return strSeries.slice(0);
    },*/

    showModal: function () {
      this.isModalVisible = true;
    },

    closeModal: function () {
      this.isModalVisible = false;
    },

    alertFunctionNA: function () {
      this.modalBox.title = 'Sorry...';
      this.modalBox.msg =
        'Diese Funktion befindet sich noch in der Entwicklung und steht im aktuellen Release noch nicht zur Verfügung. ';
      this.modalBox.btnCaption = 'Alles klar!';
      this.modalBox.show = true;
    },

    alertMaxFilesReached: function () {
      this.modalBox.title = 'Maxanzahl erreicht';
      this.modalBox.msg =
        'Sie können maximal ' + this.dropzoneOptions.maxFiles + ' hochladen!';
      this.modalBox.btnCaption = 'Alles klar!';
      this.modalBox.show = true;
    },

    hideModalBox: function () {
      this.modalBox.title = '';
      this.modalBox.message = '';
      this.modalBox.buttonCaption = '';
      this.modalBox.show = false;
    },

    maxFileCountReached: function (file) {
      this.alertMaxFilesReached();
      this.removeFile(file);
    },

    showSlpProfile: function () {
      this.isSlpProfileVisible = true;
    },

    closeSlpProfile: function () {
      this.isSlpProfileVisible = false;
    },

    getZoom: function () {
      return this.zoom / 100;
    },

    fetchData: function () {
      if (this.$route.params.files) {
        this.files = this.$route.params.files;
      }
    },

    saveTimeSerie: function (f) {
      var ts = f.series[0];
      ts.id = '' + new Date().getUTCMilliseconds();
      var url =
        'https://iles4b4z6f.execute-api.us-west-2.amazonaws.com/dev/put_ts';
      var formData = new FormData();
      formData.append('timeseries', JSON.stringify(ts));
      fetch(url, { body: formData, method: 'put' }).then(
        (response) => response
      );
    },

    addNewFile: function (timeSeries) {
      var f = {
        id: timeSeries.id,
        name: 'Lastgang ID: ' + timeSeries.id,
        selected: false,
        loading: true,
        dataForExcel: null,
      };
      this.$set(this.files, this.files.length, f);
      f.series = [];
      f.series[0] = timeSeries;
      f.dataForExcel = this.initExcelData(f);
      this.hideDropZone();
      this.hideLoadingIcon(f);
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style scoped>
.no-data {
  display: block;
  width: 100%;
  position: absolute;
}

.options {
  margin: 135px 130px;
  height: 296px;
}

.no-data .option h2 {
  font-size: 24px;
  color: #444f62;
  font-weight: 500;
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  text-transform: uppercase;
}

.no-data .option .logo {
  margin-top: 50px;
  margin-bottom: 35px;
}

.option img {
  height: 66px;
}

.no-data .option {
  width: 50%;
  display: inline-block;
  height: 296px;
  padding: 0 80px;
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */
}

.border-reight {
  border-right: 1px solid #d9dde2;
}

.no-data .slp {
  zoom: 1.1;
}
.modal-window {
  position: absolute;
  z-index: 16;
}

.board-body {
  width: 100%;
  min-height: 200px;
  text-align: center;
  color: #5f697a;
  display: block;
  border-top: 1px solid rgb(231, 231, 232);
}

.dragNDropBackGround {
  cursor: pointer;
  background-image: url('../assets/img/drag-n-drop.png');
  background-size: 1100px 1118px;
  background-position: 50% 25px;
  background-repeat: no-repeat;
  overflow: hidden;
  width: 348px;
  display: inline-block;
  text-indent: -9999px;
  font-size: 0;
  line-height: 0;
  opacity: 0.95;
}

.customdropzone {
  padding: 110px 80px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizelegibility;
  width: 100%;
  transition: background-color 0.2s linear;
  font-family: 'Open Sans', open-sans, sans-serif;
  font-size: 12px;
  min-height: 400px;
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box; /* Firefox, other Gecko */
  box-sizing: border-box; /* Opera/IE 8+ */
}

.customdropzone .dz-preview {
  float: left;
  display: inline-block;
  position: relative;
  width: 325px;
  height: 314px;
  margin: 0 30px 30px 0;
  border-radius: 4px;
  -webkit-box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05),
    0 1px 2px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.customdropzone .dz-preview.large {
  height: 423px;
}
.customdropzone .dz-preview.large.margin {
  margin: 30px;
}

.customdropzone.margin {
  padding-top: 80px;
}

.dz-message {
  color: #808ca7;
  margin-top: 35px;
}
.dz-message h2 {
  font-size: 43px;
  font-weight: 600;
  color: #808ba7;
  margin-top: 13px;
}
.dz-message p {
  font-size: 18px;
  font-weight: 100;
}
.dz-started .dz-message {
  display: none;
}
.customdropzone .dz-preview:hover {
  transform: translateY(-4px);
  box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.3), 0 0 1px 0 rgba(0, 0, 0, 0.2);
}

.customdropzone .dz-preview.loading:hover {
  transform: none;
  box-shadow: none;
}

.customdropzone .dz-preview.checked {
  transform: translateY(-4px);
  -webkit-box-shadow: 0 0 0 2px #1fc281;
  box-shadow: 0 0 0 2px #1fc281;
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
}

.customdropzone .dz-preview.checked .dz-image .data-dz-thumbnail-bg-overlay {
  opacity: 1;
}

.customdropzone .dz-preview .dz-image {
  height: 287px;
  top: 0;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg {
  z-index: 1;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 287;
  width: 100%;
  position: absolute;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg.large {
  height: 419px;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg.loading {
  z-index: 4000;
  height: 100%;
  border-radius: 4px;
  opacity: 1;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay:hover {
  opacity: 1;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay {
  z-index: 5;
  top: 0;
  overflow: hidden;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  left: 0;
  height: 287;
  width: 100%;
  position: absolute;
  top: 0;
  opacity: 0;
  background-color: rgba(25, 29, 38, 0.85);
  -webkit-transition: opacity 450ms ease-in-out;
  -o-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay.large {
  height: 423px;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay.loading {
  height: 314px;
  border-radius: 4px;
  opacity: 1;
}

.customdropzone .dz-preview .dz-image > div {
  width: inherit;
  height: inherit;
  background-size: contain;
}

.customdropzone .dz-preview .dz-image > img {
  width: 100%;
}

.customdropzone .dz-success-mark,
.dz-error-mark,
.dz-remove {
  display: none;
}

.customdropzone .dz-preview .dz-progress {
  opacity: 1;
  height: 16px;
  width: 80px;
  background: hsla(0, 0%, 100%, 0.9);
  transform: scale(1);
  border-radius: 8px;
  overflow: hidden;
}

.customdropzone .dz-preview .dz-details {
  margin: 20px 0 0;
}

.customdropzone .tools {
  position: absolute;
  right: 17px;
  top: 7px;
  z-index: 2;
  border: 0px solid transparent;
  -webkit-transition: visibility 0s ease 450ms, -webkit-box-shadow 0.2s ease;
  -o-transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease;
  transition: visibility 0s ease 450ms, box-shadow 0.2s ease,
    -webkit-box-shadow 0.2s ease;
}

.customdropzone .tools li {
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 0;
  margin: 0 0 0 12px;
}

.customdropzone .tools a {
  text-indent: -9999px;
}

.customdropzone a.btn-oval {
  font-family: brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  top: 86px;
  left: 78px;
  width: 166px;
  height: 36px;
  line-height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 36px;
  color: #fff;
  transition: all 0.2s ease-in-out;
  z-index: 2;
  position: absolute;
  text-decoration: none;
}

.customdropzone a.btn-oval.mt-l {
  top: 186px;
}

.customdropzone a.btn-oval:hover {
  color: rgba(25, 29, 38, 0.85);
  background-color: white;
}

.zoom {
  width: 170px;
  position: absolute;
  margin-left: 72%;
  margin-top: -354px;
}

.zoom input[type='range'] {
  width: 100%;
}

.customdropzone .tools li > a {
  zoom: 1.2;
  opacity: 0.7;
  background-image: url('../assets/img/project-sprite.png');
  background-size: 882px 840px;
  background-position: -868px -268px;
  width: 14px;
  height: 13px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  -webkit-transition: opacity 0.2s ease-in-out;
  -o-transition: opacity 0.2s ease-in-out;
}

.customdropzone .tools li > a:hover {
  opacity: 1;
}

.customdropzone .tools li.share a {
  background-position: -868px -268px;
}

.customdropzone .tools li.download a {
  background-position: -868px -646px;
}

.customdropzone .tools li.delete a {
  background-position: -129px -759px;
}

ul li {
  line-height: 17px;
}

li {
  display: list-item;
  text-align: -webkit-match-parent;
}

.customdropzone .dz-preview .dz-details h2 {
  font-size: 14px;
  line-height: 20px;
  display: inline-block;
  position: relative;
  padding: 0 30px;
  color: #47506e;
  font-weight: 400;
  margin: 0;
}

.customdropzone .dz-preview .dz-details .rename {
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0 0 1px;
}

.customdropzone .dz-preview .dz-details .rename:hover:after {
  background-image: url(../assets/img/project-sprite.png);
  background-size: 882px 840px;
  background-position: -728px -691px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  width: 12px;
  height: 12px;
  top: 0;
  right: 0;
  position: absolute;
  content: '';
  margin: 4px 10px 0 0;
}

.customdropzone .dz-preview .dz-image .data-dz-thumbnail-bg-overlay.checked {
  -webkit-box-shadow: 0 0 0 30px #1fc281;
  box-shadow: 0 0 0 30px #1fc281;
  -webkit-transition: none;
  -o-transition: none;
  transition: none;
  opacity: 1;
}

.customdropzone
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay
  div.checker {
  height: 20px;
  width: 20px;
  margin: 14px 0 0 16px;
  -webkit-transition: opacity 0.2s ease;
  -o-transition: opacity 0.2s ease;
  transition: opacity 0.2s ease;
  opacity: 0.7;
  z-index: 1;
  display: block;
  line-height: 21px;
  position: relative;
  zoom: 1;
  position: relative;
}

.customdropzone
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay
  div.checker:hover {
  opacity: 1;
}

.checker input,
.checker input[type='checkbox'] {
  cursor: pointer;
  visibility: visible;
  height: 21px;
  width: 20px;
  display: inline-block;
  background: 0 0;
  opacity: 0;
}

.customdropzone
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay
  div.checker
  span {
  background-image: url('../assets/img/project-sprite.png');
  background-size: 882px 840px;
  background-position: -488px -386px;
  height: 20px;
  width: 20px;
  background-repeat: no-repeat;
  overflow: hidden;
  display: block;
  text-align: center;
}
.customdropzone
  .dz-preview
  .dz-image
  .data-dz-thumbnail-bg-overlay
  div.checker
  span.checked {
  background-position: -398px -283px;
}

input[type='checkbox'],
input[type='radio'] {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  outline: 0;
  margin: 0 0 9px;
  font-size: 100%;
  vertical-align: middle;
  display: inline-block;
}

.group-actions {
  display: block;
  background: #fff;
  position: fixed;
  bottom: 0;
  box-shadow: 0 -1px 0 rgba(76, 86, 103, 0.2),
    0 -2px 35px rgba(31, 37, 50, 0.14);
  z-index: 1000;
  left: 0;
  width: 100%;
  height: 76px;
  padding: 10px 35px;
  transition: transform 0.3s ease, -webkit-transform 0.3s ease;
  text-align: center;
  float: left;
  clear: both;
}

.group-actions .inner {
  width: 100%;
  text-align: left;
  display: block;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
}

.selected-items {
  font-size: 11px;
  border-radius: 100px;
  background: #54c08a;
  color: #fff;
  padding: 1px 14px 0px;
  margin: 1px 6px 0 0;
  float: left;
  font-weight: 600;
}
.selected-items-label {
  float: left;
  font-size: 12px;
  color: #4a556b;
  font-weight: 600;
  text-transform: uppercase;
  float: left;
  margin: 1px 0 0 10px;
  text-rendering: optimizelegibility;
}
.group-actions .toolbar {
  margin: 3px 0 0 -179px;
  position: absolute;
  left: 50%;
}
.toolbar .list-item {
  float: left;
  margin: 0 15px;
  list-style: none;
  padding: 0;
  display: list-item;
  text-align: -webkit-match-parent;
}

.toolbar .list-item .link {
  cursor: pointer;
  top: 50%;
  display: block;
  text-indent: -9999px;
  opacity: 0.9;
  background-size: 882px 840px;
  width: 16px;
  height: 16px;
  background-repeat: no-repeat;
  display: block;
  overflow: hidden;
}

.toolbar .share .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: 0 -759px;
}

.toolbar .delete .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: -868px 0;
  width: 14px;
  height: 18px;
}

.toolbar .download .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: -800px 0;
  width: 18px;
  height: 18px;
}
.toolbar .more {
  margin-top: 8px;
}

.toolbar .more .link {
  background-image: url(../assets/img/project-sprite.png);
  background-position: -463px -759px;
  width: 18px;
  height: 4px;
}

.dropdown {
  padding-left: 0px;
  font-size: 14px;
  color: #4a556a;
  font-family: sans-serif;
  -webkit-font-smoothing: unset;
}

.dropdown-menu {
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 0px;
  list-style-type: none;
  border: 0;
  border-radius: 2px;
  -webkit-box-shadow: 0 2px 35px rgba(31, 37, 50, 0.14),
    0 0 0 1px rgba(76, 86, 103, 0.2);
  box-shadow: 0 2px 35px rgba(31, 37, 50, 0.14),
    0 0 0 1px rgba(76, 86, 103, 0.2);
  bottom: 10px;
  position: absolute;
  z-index: 100;
  min-width: 195px;
  list-style: none;
  background-color: #fff;
}

.dropdown .list-item {
  margin: 0px;
}

.toolbar .more .dropdown .dropdown-menu .link {
  padding-top: 5px;
  padding-right: 20px;
  padding-bottom: 5px;
  padding-left: 20px;
  width: auto;
  display: list-item;
  list-style: none;
  background: #fff;
  text-indent: 0;
  height: 25px;
  line-height: 18px;
}

.button-wrapper {
  width: 200px;
  display: block;
  margin-left: 80%;
  margin-top: -434px;
  position: absolute;
  height: 60px;
}

.plus-button {
  cursor: pointer;
  display: block;
  color: white;
  border-radius: 50%;
  background-color: rgb(255, 51, 102);
  height: 60px;
  width: 60px;
  line-height: 59px;
  font-size: 30px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
}

.plus-button.clicked {
  transform: rotate(45deg);
}

.plus-button:hover {
  transform: scale(1.1) rotate(0);
}

.plus-button.clicked:hover {
  transform: scale(1.1) rotate(45deg);
}

.plus-btn-options {
  display: block;
  position: absolute;
  margin-top: -360px;
  margin-left: 60%;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
}

.plus-btn-options .option {
  text-align: center;
  display: inline-block;
  padding: 47px 15px 45px;
  border-right: solid 1px #dbdee5;
  cursor: pointer;
  width: 165px;
}

.file-icon {
  background-image: url('../assets/img/project-sprite.png');
  background-size: 882px 840px;

  background-repeat: no-repeat;
  overflow: hidden;
  display: block;

  cursor: pointer;
  margin: 0 auto;
  height: 64px;
}

.plus-btn-options .option h2 {
  font: 600 15px/22px brandon-grotesque, 'Open Sans', open-sans, sans-serif;
  color: #434c5e;
  text-transform: uppercase;
  margin-top: 14px;
  margin-bottom: 0px;
}

.option p {
  font-size: 13px;
  line-height: 22px;
  color: #596377;
  margin: 0;
  padding: 0;
  font-family: inherit;
  text-rendering: optimizelegibility;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
}

.file {
  background-position: -712px 9px;
  width: 38px;
}

.slp {
  background-position: -662px -755px;
  width: 64px;
}

.accessibility {
  left: 64px;
  /*width: 20px !important;*/
}

.progress-icon {
  display: block;
  position: relative;
  left: 127px;
  top: 108px;
  width: 70px;
  height: 70px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon 1.2s linear infinite;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.margin {
  margin: 20px;
}
</style>
